import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

const SITE = "https://www.tonouhmarketing.com";
const LOCALES = { en: "en_US", nl: "nl_NL" };

function upsertMeta(key, attr, content) {
  let el = document.head.querySelector(`meta[${key}="${attr}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(key, attr);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href, hreflang = null) {
  const sel = hreflang
    ? `link[rel="${rel}"][hreflang="${hreflang}"]`
    : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description }) {
  const { lang } = useLang();
  const { pathname } = useLocation();
  const rest = pathname.replace(/^\/(en|nl)/, "");

  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:locale", LOCALES[lang]);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertLink("canonical", `${SITE}${pathname}`);
    [["en", "en"], ["nl", "nl"], ["x-default", "en"]].forEach(([h, l]) => {
      upsertLink("alternate", `${SITE}/${l}${rest}`, h);
    });
  }, [title, description, lang, pathname, rest]);

  return null;
}
